import React from "react";
import { Paper, Popover, MenuList, ClickAwayListener } from "@material-ui/core";
import Item from "./Item";

const PopoverMenu = ({ items, anchorRef, popoverOpen, closePopover }) => {
  return (
    <Popover
      open={popoverOpen}
      anchorEl={anchorRef}
      onClose={closePopover}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Paper>
        <ClickAwayListener onClickAway={closePopover}>
          <MenuList>
            {items.map((item) => (
              <Item {...item} onItemClick={closePopover} />
            ))}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popover>
  );
};

export default PopoverMenu;
